export const COMPARE_ADD_ITEM = 'COMPARE_ADD_ITEM';
export const COMPARE_REMOVE_ITEM = 'COMPARE_REMOVE_ITEM';
